import { IconCheckOutline18 as Check } from "nucleo-ui-outline-18"

import type { PainLevel } from "@productlane/db"
import type { IconType } from "@productlane/ui/src/icons"
import { cn } from "@productlane/lib/src/browser"
import { PriorityIcons, PriorityNaming } from "@productlane/ui"
import { CommandItem } from "@productlane/ui/src/components/internal/command"

import type { SharedFilterItemsProps } from "./types"
import { useThreadsFilterState } from "../threads-filter-state"

const painLevels = ["UNKNOWN", "LOW", "MEDIUM", "HIGH"]

export function PriorityFilterItems({ onSelect }: SharedFilterItemsProps) {
	const {
		painLevels: selectedPainLevels,
		addPainLevel,
		removePainLevel,
	} = useThreadsFilterState()

	return (
		<>
			{painLevels.map((painLevel) => {
				const pl = painLevel as PainLevel
				return (
					<CommandItem
						onSelect={() => {
							if (selectedPainLevels.includes(pl)) {
								removePainLevel(pl)
							} else {
								addPainLevel(pl)
							}
							onSelect()
						}}
						key={pl}
						Icon={PriorityIcons[pl] as IconType}
					>
						<div className="flex w-full items-center gap-2">
							<span className="flex-1 truncate">{PriorityNaming[pl]}</span>
							<Check
								className={cn("h-4 w-4 shrink-0", {
									"opacity-100": selectedPainLevels.includes(pl),
									"opacity-0": !selectedPainLevels.includes(pl),
								})}
							/>
						</div>
					</CommandItem>
				)
			})}
		</>
	)
}
